"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeverityLevels = void 0;
/**
 * Custom set of severity levels that fits our implementation. Based on PINOs underlying logic
 *
 * See more at https://github.com/pinojs/pino/blob/master/docs/api.md#loggerlevel-string-gettersetter
 */
let SeverityLevels = exports.SeverityLevels = /*#__PURE__*/function (SeverityLevels) {
  /**
   * The least important of all message levels. Will be ommited during production
   */
  SeverityLevels[SeverityLevels["DEBUG"] = 5] = "DEBUG";
  /**
   * Serves as a proxy to debug level and behaves the same
   */
  SeverityLevels[SeverityLevels["INFO"] = 10] = "INFO";
  /**
   * Serves as tracking level for application events and their time to finish
   */
  SeverityLevels[SeverityLevels["METRIC"] = 15] = "METRIC";
  /**
   * Warns about non breaking important events
   */
  SeverityLevels[SeverityLevels["WARN"] = 40] = "WARN";
  /**
   * Serves as level that notifies about critial events that
   * happened in application and most likely broke something
   */
  SeverityLevels[SeverityLevels["ERROR"] = 50] = "ERROR";
  return SeverityLevels;
}({});
//# sourceMappingURL=SeverityLevels.js.map